import type { ClientCatalogProps } from "@core/SitePresenter/SitePresenter";
import getCatalogEditProps from "@ext/catalog/actions/propsEditor/logic/getCatalogEditProps";
import type CatalogEditProps from "@ext/catalog/actions/propsEditor/model/CatalogEditProps";
import type { Property } from "@ext/properties/models";

interface PersistCatalogPropertyOrderDependencies {
	save: (props: CatalogEditProps) => Promise<boolean>;
	update: (properties: Property[]) => void;
}

export const persistCatalogPropertyOrder = async (
	catalogProps: ClientCatalogProps,
	properties: Property[],
	{ save, update }: PersistCatalogPropertyOrderDependencies,
): Promise<boolean> => {
	const previousProperties = catalogProps.properties ?? [];
	const nextProps = { ...getCatalogEditProps(catalogProps), properties };

	update(properties);

	try {
		if (await save(nextProps)) return true;
	} catch {
		// The request layer reports the error; this operation owns only its optimistic state.
	}

	update(previousProperties);
	return false;
};
